module.exports = __webpack_public_path__ + "img/vegetable-peppers-190x100.11c30a88.jpg";